/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type {
  TrafficFilterRulesetInfo,
  TrafficFilterRulesetRequest,
} from '@modules/cloud-api/v1/types'

export const makeHostedUpsertRequest = (
  ruleset: TrafficFilterRulesetInfo,
): TrafficFilterRulesetRequest => ({
  name: ruleset.name,
  description: ruleset.description,
  type: ruleset.type,
  include_by_default: ruleset.include_by_default,
  region: ruleset.region,
  rules: ruleset.rules,
})
